/**
 * Mapping Definition
 *
 * key = vue2 path name / requested by most of the APIs
 * value = vue3 path name / new schema, used in the frontend and also by the client search
 */
export const zahlpersonMapping = {
  salutation_id: 'anredeId',
  firstname: 'vorname',
  lastname: 'nachname',
  title: 'titel',
  birthday: 'geburtsdatum',
  street: 'adresse.strasse',
  street_number: 'adresse.hausnummer',
  zip_code: 'adresse.plz',
  city: 'adresse.ort',
  iban_code: 'bankverbindung.iban',
  swift_code: 'bankverbindung.bic',
  bank_name: 'bankverbindung.bankname',
};

export type ZahlpersonMappingKeys = keyof typeof zahlpersonMapping;
